export default __webpack_public_path__ + "static/media/crown.83a636c7.svg";